import { lazy } from 'react';
/** Открывает список клиентов */
export const ClientsPageAsync = lazy(() => import('./Clients/ClientsPage'));